import { IApiResponse } from "src/common/ApiResponse";
import { callApi } from "./SharedServiceFunctions";

export enum ValidationMode {
  BUSINESS = "Business",
  LEGACY_BUSINESS = "LegacyBusiness"
}

export interface IAddressValidationRequest {
  country: string;
  region: string;
  city: string;
  address_line1: string;
  address_line2?: string;
  address_line3?: string;
  postal_code: string;
  validation_mode: ValidationMode;
  secondary_validation_mode: ValidationMode;
}

export interface IAddressValidationResponseAddress {
  address_line1: string;
  address_line2?: string;
  address_line3?: string;
  city: string;
  postal_code: string;
  region: string;
  country: string;
  is_valid: boolean;
}

export interface IAddressValidationResponse {
  suggested_address: IAddressValidationResponseAddress;
  original_address: IAddressValidationResponseAddress;
  status: string;
  basic_validation_succeeded: boolean;
  secondary_status: string;
  secondary_validation_succeeded: boolean;
  suggested_addresses: IAddressValidationResponseAddress[];
  validation_message: string;
  extension_data: string;
}

export class TradescreenService {
  private API_URL = process.env.REACT_APP_INTERNAL_API_BASEURL_V2;

  public async validateAddress(addressValidationRequest: IAddressValidationRequest): Promise<IApiResponse<IAddressValidationResponse>> {
    return await callApi<IAddressValidationResponse>(`${this.API_URL}/tradescreen/addresses/validate`, JSON.stringify(addressValidationRequest), "POST");
  }
}

const tradescreenService = new TradescreenService();
export default tradescreenService;
